
import './styles/ProgressBar.css';

function ProgressBar(props: any) {

    // If there was any change.
    let changed = props.changed;
    return (
      <div className={'progress_bar__parent' + (changed === true ? ' progress_bar_color' : ' progress_bar_grey_color')}>
      </div>
    );
}

export default ProgressBar;
